import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

import { checkValidity, getUrlSegment } from '../../../helpers';

export const PublicStart = observer(class PublicStart extends React.Component {
  constructor() {
    super();

    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      assessmentGroupSid: '',
      formError: false,
      formErrorReason: ''
    }
  };

  handleInput(val, field) {
    this.setState({[field]: val});
  };

  handleSubmit(e) {
    const { store, translation } = this.props;
    const { firstName, lastName, email, assessmentGroupSid } = this.state;
    const { AssessmentStore } = store;
    // eslint-disable-next-line
    const validEmail = email.match(/^[\w+-\.]+@([\w-]+\.)+[\w+-]{2,4}$/);

    e.preventDefault();

    if (!firstName || !lastName || !email) {
      this.setState({
        formError: true,
        formErrorReason: translation.errors.empty_fields
      });

      return;
    } else if (!validEmail) {
      this.setState({
        formError: true,
        formErrorReason: translation.errors.invalid_email
      });
      return;
    } else {
      this.setState({
        formError: false,
        formErrorReason: ''
      });

      //Make api call
      const payload = {
        groupSid: assessmentGroupSid,
        user: {
          firstName,
          lastName,
          email
        }
      };

      const callback = (response) => {
        if (response === 'user-already-exists') {
          this.setState({
            formError: true,
            formErrorReason: translation.errors.user_already_exists
          })
        }
      }
      AssessmentStore.provisionAssessment(payload, callback);
    }
  };

  componentDidMount() {
    // If no assessment group is found redirect to unauthorized page
    if (!getUrlSegment(2)) {
      window.location = '/unauthorized';
    } else {
      this.setState({ assessmentGroupSid: getUrlSegment(2)});
    }
  }

  render() {
    const { translation } = this.props;
    const { formError, formErrorReason } = this.state;
    const backgroundImage = 'url(../img/compass.JPG)';

    return (
      <main
        id="main-content"
        className="page page--graphic page--pane-right"
        tabIndex="-1"
        aria-labelledby="page-title"
        style={{backgroundImage: backgroundImage}}
      >
        <div className='wrap'>
          <div className='pane pane--right pane--fixed'>
            <div className='pane__content'>
              <h1 className='pane__title'>{translation.title}</h1>
              
              {translation.welcome_text.map((text, i) => {
                return <p key={`welcome-text-${i}`}>{text}</p>
              })}

              {formError &&
                <p className='error'>{formErrorReason}</p>
              }

              <form
                onSubmit={(e) => checkValidity(e, this.handleSubmit(e))}
                className='form'
                noValidate
              >
                <fieldset>
                  <ul className='form__fields'>
                    <li>
                      <label className='meta' htmlFor='first-name'>{translation.first_name}</label>
                      <input
                        type='text'
                        placeholder={translation.first_name}
                        id='first-name'
                        data-errormsg={translation.first_name_required}
                        onChange={(e) => this.handleInput(e.target.value, 'firstName')}
                        required
                      />
                    </li>
                    <li>
                      <label className='meta' htmlFor='last-name'>{translation.last_name}</label>
                      <input
                        type='text'
                        placeholder={translation.last_name}
                        id='last-name'
                        data-errormsg={translation.last_name_required}
                        onChange={(e) => this.handleInput(e.target.value, 'lastName')}
                        required
                      />
                    </li>
                    <li>
                      <label className='meta' htmlFor='email'>{translation.email}</label>
                      <input
                        type='email'
                        placeholder={translation.email}
                        data-errormsg={translation.email_required}
                        id='email'
                        onChange={(e) => this.handleInput(e.target.value, 'email')}
                        required
                      />
                    </li>
                  </ul>
                </fieldset>

                <button type='submit' className='btn'>{translation.continue}</button>
                <a
                  href='https://smarterservices.com/privacy-policy/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {translation.privacy_policy}
                </a>
              </form>
            </div>
          </div>
        </div>
      </main>
    )
  }
})

export default translate('PublicStart')(PublicStart)